exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ds-form-field-combined-input{display:flex;width:100%}.ds-form-field-combined-input .ds-button,.ds-form-field-combined-input .ds-slim-button{border-bottom-left-radius:0;border-top-left-radius:0;flex-shrink:0;padding-left:var(--ds-grid-gap);padding-right:var(--ds-grid-gap)}.ds-form-field-combined-input .ds-button--icon,.ds-form-field-combined-input .ds-slim-button--icon{padding-left:.375rem;padding-right:.375rem}.ds-form-field-combined-input .ds-form-input{border-bottom-right-radius:0;border-top-right-radius:0}.ds-form-field-combined-input .ds-button--secondary.ds-button--inverse,.ds-form-field-combined-input .ds-slim-button--inverse{border-width:.0625rem}", ""]);

// exports
exports.locals = {
	"ds-form-field-combined-input": "ds-form-field-combined-input",
	"ds-button": "ds-button",
	"ds-slim-button": "ds-slim-button",
	"ds-button--icon": "ds-button--icon",
	"ds-slim-button--icon": "ds-slim-button--icon",
	"ds-form-input": "ds-form-input",
	"ds-button--secondary": "ds-button--secondary",
	"ds-button--inverse": "ds-button--inverse",
	"ds-slim-button--inverse": "ds-slim-button--inverse"
};